module.exports = __webpack_public_path__ + "static/media/b10.4cd5d685.png";